import borders from "../../base/borders";
import colors from "../../base/colors";

import pxToRem from "../../functions/pxToRem";
import linearGradient from "../../functions/linearGradient";

const { borderWidth } = borders;
const { transparent, primary, grey } = colors;

const checkbox = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      padding: pxToRem(6),

      "& .MuiSvgIcon-root": {
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        width: pxToRem(18),
        height: pxToRem(18),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${grey[500]}`,
        borderRadius: pxToRem(4),
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        outline: `${borderWidth[2]} solid ${primary.main}`,
        outlineOffset: pxToRem(1),
      },
    },

    colorPrimary: {
      color: grey[500],

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
            primary.main,
            primary.main
          )}`,
          borderColor: primary.main,
        },
      },
    },

    colorSecondary: {
      color: grey[500],

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
            primary.main,
            primary.main
          )}`,
          borderColor: primary.main,
        },
      },
    },
  },
};

export default checkbox;
